"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapInsightListItemWithDrag = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var model_1 = require("../../model");
var useDashboardDrag_1 = require("./useDashboardDrag");
var useWidgetDragEndHandler_1 = require("./draggableWidget/useWidgetDragEndHandler");
var sizing_1 = require("../../_staging/layout/sizing");
var sdk_ui_ext_1 = require("@gooddata/sdk-ui-ext");
/**
 * @internal
 */
function WrapInsightListItemWithDrag(_a) {
    var children = _a.children, insight = _a.insight;
    var isInEditMode = model_1.useDashboardSelector(model_1.selectIsInEditMode);
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var handleDragEnd = useWidgetDragEndHandler_1.useWidgetDragEndHandler();
    var _b = tslib_1.__read(useDashboardDrag_1.useDashboardDrag({
        dragItem: function () {
            var sizeInfo = sizing_1.getSizeInfo(settings, "insight", insight);
            return {
                type: "insightListItem",
                insight: insight,
                size: {
                    gridHeight: sizeInfo.height.default || sdk_ui_ext_1.INSIGHT_WIDGET_SIZE_INFO_DEFAULT.height.default,
                    gridWidth: sizeInfo.width.default || sdk_ui_ext_1.INSIGHT_WIDGET_SIZE_INFO_DEFAULT.width.default,
                },
            };
        },
        canDrag: isInEditMode,
        hideDefaultPreview: false,
        dragEnd: handleDragEnd,
    }, [isInEditMode, insight, handleDragEnd]), 2), isDragging = _b[0].isDragging, dragRef = _b[1];
    return (react_1.default.createElement("div", { className: classnames_1.default({ "is-dragging": isDragging }), ref: dragRef }, children));
}
exports.WrapInsightListItemWithDrag = WrapInsightListItemWithDrag;
//# sourceMappingURL=WrapInsightListItemWithDrag.js.map